(() => {
  // Skip JS dots when native CSS scroll markers are supported
  if (CSS.supports('selector(::scroll-marker-group)')) return;

  const init = (scope = document) => {
    const carousel = scope.querySelector('.patine-testimonials__carousel');
    const dots = scope.querySelectorAll('.patine-testimonials__dot');
    const cards = carousel ? carousel.querySelectorAll('.patine-testimonial') : [];
    if (!dots.length || !cards.length) return;

    // Click dot → scroll to card
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    // Observe which card is most visible → update active dot
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = [...cards].indexOf(entry.target);
            dots.forEach((d, i) => {
              d.classList.toggle('patine-testimonials__dot--active', i === index);
            });
          }
        });
      },
      { root: carousel, threshold: 0.6 },
    );
    cards.forEach((card) => {
      observer.observe(card);
    });
  };

  init();

  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
})();
